__turbopack_context__.v({
  "description": "PopupBanner-module-scss-module__VM6oZq__description",
  "hide": "PopupBanner-module-scss-module__VM6oZq__hide",
  "icon": "PopupBanner-module-scss-module__VM6oZq__icon",
  "important": "PopupBanner-module-scss-module__VM6oZq__important",
  "pop-in": "PopupBanner-module-scss-module__VM6oZq__pop-in",
  "pop-out": "PopupBanner-module-scss-module__VM6oZq__pop-out",
  "popupBanner": "PopupBanner-module-scss-module__VM6oZq__popupBanner",
  "reveal": "PopupBanner-module-scss-module__VM6oZq__reveal",
});
